import classNames from 'classnames';
import * as React from 'react';
import { Button } from 'Views/Components/Button/Button';
import { CustomTooltip } from '../CustomTooltip/CustomTooltip';
import Icon from '../Icon/Icon';

interface InputCounterProps {
	title: string;
	subtitle?: React.ReactNode;
	statusPill?: React.ReactNode;
	tooltip?: string;
	amount: number;
	subtractDisabled: boolean;
	addDisabled?: boolean;
	className?: string;
	onSubtract: () => void;
	onAdd: () => void;
}

export default function InputCounter({
	title,
	subtitle,
	statusPill,
	tooltip,
	amount,
	subtractDisabled,
	addDisabled,
	className,
	onSubtract,
	onAdd,
}: InputCounterProps) {
	const subtractBtnAlt = `subtract-${title}`;
	const addBtnAlt = `add-${title}`;
	return (
		<div className={classNames('input-counter', className)}>
			<div className="input-counter__row">
				<div>
					<div className="input-counter-title-container">
						<p className="input-counter-title">
							{title}
							{tooltip && <CustomTooltip key="test">{tooltip}</CustomTooltip>}
						</p>
						<p className="input-counter-subtitle">{subtitle}</p>
					</div>
				</div>
				<div className="amount-controls-container">
					<Button className="amount-btn subtract" disabled={subtractDisabled} onClick={onSubtract}>
						<Icon name="remove" useMaterialIcons />
					</Button>
					<div className="amount-label-container">
						<h2 className="amount-label">{amount}</h2>
					</div>
					<Button className="amount-btn add" disabled={addDisabled} onClick={onAdd}>
						<Icon name="add" useMaterialIcons />
					</Button>
				</div>
			</div>
			{statusPill && <div className="input-counter__status-pill">{statusPill}</div>}
		</div>
	);
}
